export const objectDifference = (first, second) =>
	Object.keys(second).reduce((diff, key) => {
		if (first[key] === second[key]) return diff
		return {
			...diff,
			[key]: second[key]
		}
	}, {})
